import { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import { Autocomplete, InputAdornment, TextField } from '@mui/material';
import { SearchRounded } from '@mui/icons-material';
import { FocusEvent, ReactElement } from 'react';

// Types
export interface ILabelType {
  description?: string;
  id: string;
  label: string;
  name?: string;
}

export interface ITypeaheadOption {
  id: string;
  label: string;
}
export interface ITypeaheadProps {
  id?: string;
  options?: ITypeaheadOption[];
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onChange?: (e, value: ITypeaheadOption | null) => void;
  value?: ITypeaheadOption;
  placeholder?: string;
  name?: string;
  className?: string;
}

const Typeahead = (props: ITypeaheadProps): ReactElement => {
  const { options, placeholder, onChange, value, className, name } = props;

  const renderField = (params: AutocompleteRenderInputParams): ReactElement => {
    params.InputProps.startAdornment = (
      <InputAdornment position="start">
        <SearchRounded />
      </InputAdornment>
    );
    params.InputProps.endAdornment = null;
    return (
      <TextField
        {...params}
        placeholder={placeholder}
        variant="outlined"
        slotProps={{ htmlInput: { ...params.inputProps, 'aria-label': placeholder, id: name } }}
      />
    );
  };
  const getOptionLabel = (option: ITypeaheadOption): string => option.label || '';

  return (
    <Autocomplete
      aria-label={props.name}
      sx={{ padding: '0.5rem 0.25rem !important' }}
      className={className}
      freeSolo
      getOptionLabel={getOptionLabel}
      inputValue={value?.label || ''}
      onChange={onChange}
      options={options || []}
      renderInput={renderField}
      style={{ minWidth: '50%' }}
      title={placeholder}
      value={value}
    />
  );
};

export default Typeahead;
